<template>
  <v-dialog
    v-model="navigation.CRMWhatsappContactURLLocationDialogIsVisible"
    @update:model-value="navigation.CRMWhatsappContactURLLocationDialogIsVisible == false ? closeCRMWhatsappContactURLLocationDialog() : null"
    max-width="65vw"
    @contextmenu.prevent="null"
    style="user-select: none; cursor: default;"
  >
    <v-card>
      <div style="max-height: 90vh; display: flex; flex-direction: column;">
        <div style="position: sticky; top: 0; z-index: 10; background: white;">
          <v-card color="primary" rounded="0" elevation="0">
            <div class="twoColumnContainer">
              <div class="titleContainer">
                <div style="display: flex; align-items: center;">
                  <v-icon color="indigo" size="large">mdi-map-marker</v-icon>
                  <v-icon color="indigo" style="margin-right: 10px;">{{ {'insert': 'mdi-plus-circle', 'update': 'mdi-pencil', 'delete': 'mdi-delete'}[navigation.CRMWhatsappContactURLLocationDialogAction] }}</v-icon>
                  <h3>{{ {'insert': 'AGREGAR', 'update': 'ACTUALIZAR', 'delete': 'ELIMINAR'}[navigation.CRMWhatsappContactURLLocationDialogAction] }} UBICACIÓN DEL CONTACTO</h3>
                </div>
              </div>
              <div class="buttonsContainer">
                <v-btn @click="closeCRMWhatsappContactURLLocationDialog()" color="error" class="hoverableText">
                  <v-icon style="margin-right: 10px;">mdi-close-circle</v-icon>
                  <p>CERRAR</p>
                </v-btn>
              </div>
            </div>
          </v-card>
          <v-card color="indigo" elevation="0" rounded="0" style="height: 2px;"></v-card>
        </div>
        <div style="flex: 1; overflow-y: auto;">
          <template v-if="loader.getSystemInformationData || loader.selectCRMWhatsappContactURLLocationFromCRMWhatsappContactURLLocationDialog">
            <div style="height: 500px; width: 100%;">
              <AppLoaderScreen
                :appLogoSize="'x-small'"
                :loadingText="'Cargando ubicación del contacto'"
                :dotsToAnimate="3"
                style="width: 100%; height: 100%;"
              ></AppLoaderScreen>
            </div>
          </template>
          <template v-else>
            <div style="padding: 15px;">
              <v-text-field
                ref="CRMWhatsappContactLatitudeLongitudeLocationName"
                v-model="input.CRMWhatsappContactURLLocationName"
                :loader="loader.generalLoader"
                :disabled="loader.generalLoader || navigation.CRMWhatsappContactURLLocationDialogAction == 'delete'"
                label="Nombre"
                variant="outlined"
                density="compact"
                autocomplete="off"
                prepend-inner-icon="mdi-alpha-a-box"
                clearable
                hide-details
                style="margin-bottom: 15px;"
              ></v-text-field>
              <v-textarea
                v-model="input.CRMWhatsappContactURLLocationDescription"
                :loader="loader.generalLoader"
                :disabled="loader.generalLoader || navigation.CRMWhatsappContactURLLocationDialogAction == 'delete'"
                label="Descripción"
                variant="outlined"
                density="compact"
                autocomplete="off"
                prepend-inner-icon="mdi-alpha-b-box"
                rows="3"
                max-rows="5"
                auto-grow
                clearable
                hide-details
                style="margin-bottom: 15px;"
              ></v-textarea>
              <v-text-field
                ref="CRMWhatsappContactURLLocationURL"
                v-model="input.CRMWhatsappContactURLLocationURL"
                :loader="loader.generalLoader"
                :disabled="loader.generalLoader || navigation.CRMWhatsappContactURLLocationDialogAction == 'delete'"
                label="URL"
                variant="outlined"
                density="compact"
                autocomplete="off"
                prepend-inner-icon="mdi-link"
                clearable
                hide-details
                style="margin-bottom: 15px;"
              ></v-text-field>
            </div>
            <v-card color="indigo" elevation="0" style="height: 2px;"></v-card>
            <v-card color="primary" elevation="0" rounded="0" style="padding: 15px;">
              <v-tooltip :disabled="validateInputForCRMWhatsappContactURLLocationDialog(false).success" location="top"> 
                <template v-slot:activator="{ props }">
                  <div v-bind="props">
                    <v-btn 
                      @click="navigation.CRMWhatsappContactURLLocationDialogAction == 'insert' ? insertCRMWhatsappContactURLLocation() : (navigation.CRMWhatsappContactURLLocationDialogAction == 'update' ? updateCRMWhatsappContactURLLocation() : deleteCRMWhatsappContactURLLocation())" 
                      :disabled="!validateInputForCRMWhatsappContactURLLocationDialog(false).success || loader.selectCRMWhatsappContactURLLocationFromCRMWhatsappContactURLLocationDialog || loader.generalLoader" 
                      color="indigo"
                      class="hoverableText"
                      block
                    >
                      <v-icon style="margin-right: 10px;">{{ {'insert': 'mdi-plus-circle', 'update': 'mdi-pencil', 'delete': 'mdi-delete'}[navigation.CRMWhatsappContactURLLocationDialogAction] }}</v-icon>
                      <h3>{{ {'insert': 'AGREGAR', 'update': 'ACTUALIZAR', 'delete': 'ELIMINAR'}[navigation.CRMWhatsappContactURLLocationDialogAction] }} UBICACIÓN DEL CONTACTO</h3>
                    </v-btn>
                  </div>
                </template>
                <span style="max-width: 400px; display: block;">{{ validateInputForCRMWhatsappContactURLLocationDialog(false).result }}</span>
              </v-tooltip>
            </v-card>
          </template>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<style scoped>
  .twoColumnContainer {
    padding: 15px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
    align-items: center;
  }
  .titleContainer {
    display: flex;
    justify-content: flex-start;
  }
  .buttonsContainer {
    display: flex;
    gap: 10px;
    justify-content: flex-end;
  }
  .twoInputContainer {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
  }
  @media (max-width: 1200px) {
    .twoColumnContainer {
      grid-template-columns: repeat(1, 1fr);
    }
    .titleContainer {
      justify-content: center;
    }
    .buttonsContainer {
      justify-content: center;
    }
    .twoInputContainer {
      grid-template-columns: repeat(1, 1fr);
    }
  }
</style>
  
<script>
  import { systemInformation } from '@/utilities/systemInformation';
  import AppLoaderScreen from '@/components/AppLoaderScreen.vue';

  export default {
    inject: ['$generalFunctions', '$displayFunctions'],
    components: 
    {
      AppLoaderScreen
    },
    data: () => 
    ({
      input: 
      {
        CRMWhatsappContactURLLocationName: null,
        CRMWhatsappContactURLLocationDescription: null,
        CRMWhatsappContactURLLocationURL: null
      },
      navigation: 
      {
        CRMWhatsappContactID: null,
        CRMWhatsappContactURLLocationID: null,
        CRMWhatsappContactURLLocationDialogAction: null,
        CRMWhatsappContactURLLocationDialogIsVisible: false
      },
      loader: 
      {
        getSystemInformationData: false,
        generalLoader: false,
        selectCRMWhatsappContactURLLocationFromCRMWhatsappContactURLLocationDialog: false
      },
      systemInformationData: 
      {
        CRMAccountID: null,
        CRMAgentID: null,
        CRMLocalities: [],
        tooltipDisabled: false
      }
    }),

    methods:
    {
      async selectCRMWhatsappContactURLLocationFromCRMWhatsappContactURLLocationDialog(){
        this.loader.selectCRMWhatsappContactURLLocationFromCRMWhatsappContactURLLocationDialog = true;
        const selectCRMWhatsappContactURLLocationFromCRMWhatsappContactURLLocationDialogRequestQuery =
        {
          'localStorage':
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID,
            'CRMAgentID': this.systemInformationData.CRMAgentID
          },
          'CRMWhatsappContactID': this.navigation.CRMWhatsappContactID,
          'CRMWhatsappContactURLLocationID': this.navigation.CRMWhatsappContactURLLocationID
        };
        const selectCRMWhatsappContactURLLocationFromCRMWhatsappContactURLLocationDialogResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappContactLocation/functions/selectCRMWhatsappContactURLLocationFromCRMWhatsappContactURLLocationDialog', selectCRMWhatsappContactURLLocationFromCRMWhatsappContactURLLocationDialogRequestQuery);
        if (selectCRMWhatsappContactURLLocationFromCRMWhatsappContactURLLocationDialogResult.success){
          this.input.CRMWhatsappContactURLLocationName = selectCRMWhatsappContactURLLocationFromCRMWhatsappContactURLLocationDialogResult.result.CRMWhatsappContactURLLocationName;
          this.input.CRMWhatsappContactURLLocationDescription = selectCRMWhatsappContactURLLocationFromCRMWhatsappContactURLLocationDialogResult.result.CRMWhatsappContactURLLocationDescription;
          this.input.CRMWhatsappContactURLLocationURL = selectCRMWhatsappContactURLLocationFromCRMWhatsappContactURLLocationDialogResult.result.CRMWhatsappContactURLLocationURL;
          this.loader.selectCRMWhatsappContactURLLocationFromCRMWhatsappContactURLLocationDialog = false;
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog('selectCRMWhatsappContactURLLocationFromCRMWhatsappContactURLLocationDialog_error', 'error', 'Ha ocurrido un error inesperado al obtener la información de la ubicación del contacto, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
          this.closeCRMWhatsappContactURLLocationDialog();
        }
        this.loader.selectCRMWhatsappContactURLLocationFromCRMWhatsappContactURLLocationDialog = false;
      },

      async insertCRMWhatsappContactURLLocation(){
        if (this.validateInputForCRMWhatsappContactURLLocationDialog(true).success){
          this.loader.generalLoader = true;
          const insertCRMWhatsappContactURLLocationRequestQuery =
          {
            'localStorage':
            {
              'CRMAccountID': this.systemInformationData.CRMAccountID,
              'CRMAgentID': this.systemInformationData.CRMAgentID
            },
            'CRMWhatsappContactID': this.navigation.CRMWhatsappContactID,
            'CRMWhatsappContactURLLocationName': this.input.CRMWhatsappContactURLLocationName,
            'CRMWhatsappContactURLLocationDescription': this.input.CRMWhatsappContactURLLocationDescription,
            'CRMWhatsappContactURLLocationURL': this.input.CRMWhatsappContactURLLocationURL
          };
          const insertCRMWhatsappContactURLLocationResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappContactLocation/functions/insertCRMWhatsappContactURLLocation', insertCRMWhatsappContactURLLocationRequestQuery);  
          if (insertCRMWhatsappContactURLLocationResult.success){
            this.$root.notificationDialog.showSystemNotificationDialog('insertCRMWhatsappContactURLLocation_success', 'success', `Se ha agregado la ubicación "${this.input.CRMWhatsappContactURLLocationName}" del contacto`, null, true);
            this.closeCRMWhatsappContactURLLocationDialog();
          } else {
            this.$root.notificationDialog.showSystemNotificationDialog('insertCRMWhatsappContactURLLocation_error', 'error', `Ha ocurrido un error inesperado al agregar la ubicación "${this.input.CRMWhatsappContactURLLocationName}" del contacto, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema`, null, true);
          }
          this.loader.generalLoader = false;
        }
      },

      async updateCRMWhatsappContactURLLocation(){
        if (this.validateInputForCRMWhatsappContactURLLocationDialog(true).success){
          this.loader.generalLoader = true;
          const updateCRMWhatsappContactURLLocationRequestQuery =
          {
            'localStorage':
            {
              'CRMAccountID': this.systemInformationData.CRMAccountID,
              'CRMAgentID': this.systemInformationData.CRMAgentID
            },
            'CRMWhatsappContactID': this.navigation.CRMWhatsappContactID,
            'CRMWhatsappContactURLLocationID': this.navigation.CRMWhatsappContactURLLocationID,
            'CRMWhatsappContactURLLocationName': this.input.CRMWhatsappContactURLLocationName,
            'CRMWhatsappContactURLLocationDescription': this.input.CRMWhatsappContactURLLocationDescription,
            'CRMWhatsappContactURLLocationURL': this.input.CRMWhatsappContactURLLocationURL
          };
          const updateCRMWhatsappContactURLLocationResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappContactLocation/functions/updateCRMWhatsappContactURLLocation', updateCRMWhatsappContactURLLocationRequestQuery);
          if (updateCRMWhatsappContactURLLocationResult.success){
            this.$root.notificationDialog.showSystemNotificationDialog('updateCRMWhatsappContactURLLocation_success', 'success', `Se ha actualizado la ubicación "${this.input.CRMWhatsappContactURLLocationName}" del contacto`, null, true);
            this.closeCRMWhatsappContactURLLocationDialog();
          } else {
            this.$root.notificationDialog.showSystemNotificationDialog('updateCRMWhatsappContactURLLocation_error', 'error', `Ha ocurrido un error inesperado al actualizar la ubicación "${this.input.CRMWhatsappContactURLLocationName}" del contacto, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema`, null, true);
          }
          this.loader.generalLoader = false;
        }
      },
  
      async deleteCRMWhatsappContactURLLocation(){
        this.loader.generalLoader = true;
        const deleteCRMWhatsappContactURLLocationRequestQuery =
        {
          'localStorage':
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID,
            'CRMAgentID': this.systemInformationData.CRMAgentID
          },
          'CRMWhatsappContactID': this.navigation.CRMWhatsappContactID,
          'CRMWhatsappContactURLLocationID': this.navigation.CRMWhatsappContactURLLocationID
        };
        const deleteCRMWhatsappContactURLLocationResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappContactLocation/functions/deleteCRMWhatsappContactURLLocation', deleteCRMWhatsappContactURLLocationRequestQuery);
        if (deleteCRMWhatsappContactURLLocationResult.success){
          this.$root.notificationDialog.showSystemNotificationDialog('deleteCRMWhatsappContactURLLocation_success', 'success', `Se ha eliminado la ubicación "${this.input.CRMWhatsappContactURLLocationName}" del contacto`, null, true);
          this.closeCRMWhatsappContactURLLocationDialog();
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog('deleteCRMWhatsappContactURLLocation_error', 'error', `Ha ocurrido un error inesperado al eliminar la ubicación "${this.input.CRMWhatsappContactURLLocationName}" del contacto, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema`, null, true);
        }
        this.loader.generalLoader = false;
      },

      validateInputForCRMWhatsappContactURLLocationDialog(showSystemNotificationDialog){
        const regularExpressionChecker = /\S/;
        if (this.navigation.CRMWhatsappContactURLLocationDialogAction == 'delete'){
          return {success: true, result: null};
        } else if (this.input.CRMWhatsappContactURLLocationName == null || !regularExpressionChecker.test(this.input.CRMWhatsappContactURLLocationName)){
          if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForCRMWhatsappContactURLLocationName_warning', 'warning', 'El nombre de la ubicación del contacto es obligatorio', null, false);
          return {success: false, result: 'El nombre de la ubicación del contacto es obligatorio'};
        } else if (this.input.CRMWhatsappContactURLLocationName.length > 100){
          if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForCRMWhatsappContactURLLocationNameLength_warning', 'warning', 'El nombre de la ubicación del contacto no puede exceder los 100 caracteres de longitud', null, false);
          return {success: false, result: 'El nombre de la ubicación del contacto no puede exceder los 100 caracteres de longitud'};
        } else if (this.input.CRMWhatsappContactURLLocationDescription != null && this.input.CRMWhatsappContactURLLocationDescription.length > 65535){
          if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForCRMWhatsappContactURLLocationDescriptionLength_warning', 'warning', 'La descripción de la ubicación del contacto no puede exceder los 65535 caracteres de longitud', null, false);
          return {success: false, result: 'La descripción de la ubicación del contacto no puede exceder los 65535 caracteres de longitud'};
        } else if (this.input.CRMWhatsappContactURLLocationURL == null || !regularExpressionChecker.test(this.input.CRMWhatsappContactURLLocationURL)){
          if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForCRMWhatsappContactURLLocationURL_warning', 'warning', 'La URL de la ubicación del contacto es obligatoria', null, false);
          return {success: false, result: 'La URL de la ubicación del contacto es obligatoria'};
        } else if (this.input.CRMWhatsappContactURLLocationURL.length > 65535){
          if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForCRMWhatsappContactURLLocationURLLength_warning', 'warning', 'La URL de la ubicación del contacto no puede exceder los 65535 caracteres de longitud', null, false);
          return {success: false, result: 'La URL de la ubicación del contacto no puede exceder los 65535 caracteres de longitud'};
        }
        return {success: true, result: null};
      },
      
      async getSystemInformationData(){
        this.loader.getSystemInformationData = true;
        try {
          systemInformation.setGeneralFunctions(this.$generalFunctions.default);
          const systemInformationResult = await systemInformation.startup();
          if (systemInformationResult.success){
            this.systemInformationData.CRMAccountID = systemInformation.getCRMAccountID;
            this.systemInformationData.CRMAgentID = systemInformation.getCRMAgentID;
            this.systemInformationData.tooltipDisabled = systemInformation.getTooltipDisabled;
            this.systemInformationData.CRMLocalities = systemInformation.getCRMLocalities;
            this.loader.getSystemInformationData = false;
          } else {
            this.$root.notificationDialog.showSystemNotificationDialog('CRMWhatsappContactURLLocationDialog_getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
            this.closeCRMWhatsappContactURLLocationDialog();
          }
        } catch {
          this.$root.notificationDialog.showSystemNotificationDialog('CRMWhatsappContactURLLocationDialog_getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
          this.closeCRMWhatsappContactURLLocationDialog();
        }
        this.loader.getSystemInformationData = false;
      },

      async openCRMWhatsappContactURLLocationDialog(CRMWhatsappContactID, CRMWhatsappContactURLLocationID, CRMWhatsappContactURLLocationDialogAction){
        await this.getSystemInformationData();
        this.navigation.CRMWhatsappContactID = CRMWhatsappContactID;
        this.navigation.CRMWhatsappContactURLLocationID = CRMWhatsappContactURLLocationID;
        this.navigation.CRMWhatsappContactURLLocationDialogAction = CRMWhatsappContactURLLocationDialogAction;
        this.navigation.CRMWhatsappContactURLLocationDialogIsVisible = true;
        if (['update', 'delete'].includes(CRMWhatsappContactURLLocationDialogAction)) await this.selectCRMWhatsappContactURLLocationFromCRMWhatsappContactURLLocationDialog();
        if (['insert', 'update'].includes(CRMWhatsappContactURLLocationDialogAction)) this.$generalFunctions.default.focusInput(this, 'CRMWhatsappContactURLLocationName');
      },

      closeCRMWhatsappContactURLLocationDialog(){
        this.navigation.CRMWhatsappContactURLLocationDialogIsVisible = false;
        this.$emit('closeCRMWhatsappContactURLLocationDialog');
      }
    }
  }
</script>